import { takeLatest } from 'redux-saga/effects'
import {
  addContact,
  createNewContract,
  customerModuleActions,
  importZohoClientData,
  loadContractData,
  registerToNewsletter,
  saveCustomer,
  verifyEmail,
  verifyEmailLight,
  verifyItalyFiscalCode,
  verifySiret,
  verifySiretLight,
} from '../Components/Customer/CustomerModuleSagas'
import { unlockMcpClient, verifyZohoId, zohoModuleActions } from '../Components/ZohoId/ZohoModuleSagas'
import {
  addressModuleActions,
  cityEligibilityCheck,
  getPlaceDetails,
  saveAddress,
  searchAddress,
  calculateConsumption,
} from '@/containers/SubscriptionFormPageNew/Components/Address/AddressModuleSagas'
import {
  contractActions,
  loadEnergyOrigin,
  loadOfferInformation,
  loadOffers,
  loadProviderInformation,
  loadProviderOptions,
  loadProviders,
  validateContractIsNotDuplicated,
} from '@/containers/SubscriptionFormPageNew/Components/Contract/ContractSagas'
import {
  calculateOfferPrice,
  consumptionModuleActions,
} from '@/containers/SubscriptionFormPageNew/Components/Consumption/ConsumptionSagas'
import {
  checkDuplicatedPdlMeter,
  electricityMeterModuleActions,
  requestPdlMeterData,
  saveElectricityMeter,
  searchPdl,
  validatePdlMeterSyntax,
} from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/ElectricityMeterModuleSagas'
import {
  checkDuplicatedPceMeter,
  gasMeterModuleActions,
  requestPceMeterData,
  saveGasMeter,
  searchPce,
  validatePceMeterSyntax,
} from '@/containers/SubscriptionFormPageNew/Components/GasMeter/GasMeterModuleSagas'
import {
  commonActions,
  saveContract,
  saveContractFeedback,
  resendProviderEmail,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/SaveContractSagas'
import {
  additionalSalesActions,
  loadAdditionalSaleConfig,
  loadExistingAdditionalSales,
  generateGarankaUrl,
  selectVoltalisAppointment,
  getVoltalisStatus,
  voltalisCustomerCall,
  sendAxaMail,
  createAdditionalSale,
  retryAdditionalSale,
  sendAdditionalSalesCodeValidation,
  neatResendEmail,
  openPandaDocSignLink,
  protectedSendSms,
  protectedSendNewOtp,
} from '@/containers/SubscriptionFormPageNew/Components/AdditionalSales/AdditionalSalesSagas'
import {
  communicationBoardModuleActions,
  loadCommunicationBoardData,
} from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/CommunicationBoardSagas'
import {
  billingModuleActions,
  validateIban,
  fetchPromoCode,
} from '@/containers/SubscriptionFormPageNew/Components/Billing/BillingPaymentModuleSagas'
import {
  createScheduleCallback,
  loadScheduledCallbacks,
  scheduleCallbackModuleActions,
} from '@/containers/SubscriptionFormPageNew/Components/ScheduleCallback/ScheduleCallbackSagas'
import {
  clubSelectraModuleActions,
  createClubSelectra,
} from '@/containers/SubscriptionFormPageNew/Components/ClubSelectra/ClubSelectraSagas'
import {
  contractToolsActions,
  fetchExportLogs,
  fetchHistoricLogs,
  fetchUsersList,
  processChangeUser,
  retractContract,
  addCommentToContact,
  creditCheck,
} from './Common/ContractToolsSagas'
import {
  propaneModuleActions,
  loadPropaneQuoteReasons,
  loadPropaneVisibility,
} from '@/containers/SubscriptionFormPageNew/Components/Propane/PropaneModuleSagas'
import {
  energySuppliersActions,
  loadEnergySuppliers,
} from '@/containers/SubscriptionFormPageNew/Components/shared/Suppliers/EnergySuppliersSharedSagas'

export const subscriptionFormActionsV2 = {
  ...zohoModuleActions,
  ...customerModuleActions,
  ...addressModuleActions,
  ...contractActions,
  ...consumptionModuleActions,
  ...electricityMeterModuleActions,
  ...gasMeterModuleActions,
  ...commonActions,
  ...additionalSalesActions,
  ...communicationBoardModuleActions,
  ...billingModuleActions,
  ...scheduleCallbackModuleActions,
  ...clubSelectraModuleActions,
  ...contractToolsActions,
  ...propaneModuleActions,
  ...energySuppliersActions,
}

export default function* subscriptionFormV2Sagas() {
  yield takeLatest(subscriptionFormActionsV2.ZOHO_MODULE_VERIFY_ID_V2, verifyZohoId)
  yield takeLatest(subscriptionFormActionsV2.CUSTOMER_MODULE_VERIFY_EMAIL_V2, verifyEmail)
  yield takeLatest(subscriptionFormActionsV2.CUSTOMER_MODULE_VERIFY_EMAIL_LIGHT_V2, verifyEmailLight)
  yield takeLatest(subscriptionFormActionsV2.CUSTOMER_MODULE_VERIFY_SIRET_V2, verifySiret)
  yield takeLatest(subscriptionFormActionsV2.CUSTOMER_MODULE_VERIFY_SIRET_LIGHT_V2, verifySiretLight)
  yield takeLatest(subscriptionFormActionsV2.CUSTOMER_MODULE_VERIFY_ITALY_FISCAL_CODE_V2, verifyItalyFiscalCode)
  yield takeLatest(subscriptionFormActionsV2.CUSTOMER_MODULE_REGISTER_TO_NEWSLETTER_V2, registerToNewsletter)
  yield takeLatest(subscriptionFormActionsV2.ZOHO_MODULE_UNLOCK_MCP_CLIENT_V2, unlockMcpClient)
  yield takeLatest(subscriptionFormActionsV2.CUSTOMER_MODULE_SAVE_V2, saveCustomer)
  yield takeLatest(subscriptionFormActionsV2.CUSTOMER_ADD_CONTACT_V2, addContact)
  yield takeLatest(subscriptionFormActionsV2.CUSTOMER_DATA_IMPORT_ZOHO_CLIENT_V2, importZohoClientData)
  yield takeLatest(subscriptionFormActionsV2.SEARCH_ADDRESS_V2, searchAddress)
  yield takeLatest(subscriptionFormActionsV2.GET_PLACE_DETAILS, getPlaceDetails)
  yield takeLatest(subscriptionFormActionsV2.SAVE_ADDRESS, saveAddress)
  yield takeLatest(subscriptionFormActionsV2.CALCULATE_CONSUMPTION, calculateConsumption)
  yield takeLatest(subscriptionFormActionsV2.CUSTOMER_MODULE_LOAD_CONTRACT_DATA, loadContractData)
  yield takeLatest(subscriptionFormActionsV2.CONTRACT_CREATE_NEW, createNewContract)
  yield takeLatest(subscriptionFormActionsV2.CITY_ELIGIBILITY_CHECK_V2, cityEligibilityCheck)
  yield takeLatest(subscriptionFormActionsV2.OFFER_MODULE_LOAD_PROVIDERS_V2, loadProviders)
  yield takeLatest(subscriptionFormActionsV2.OFFER_MODULE_LOAD_OFFERS_V2, loadOffers)
  yield takeLatest(subscriptionFormActionsV2.OFFER_MODULE_LOAD_OFFER_INFORMATION_V2, loadOfferInformation)
  yield takeLatest(subscriptionFormActionsV2.OFFER_MODULE_LOAD_PROVIDERS_OPTIONS_V2, loadProviderOptions)
  yield takeLatest(subscriptionFormActionsV2.OFFER_MODULE_LOAD_PROVIDER_INFORMATION_V2, loadProviderInformation)
  yield takeLatest(subscriptionFormActionsV2.OFFER_MODULE_LOAD_ENERGY_ORIGIN_V2, loadEnergyOrigin)
  yield takeLatest(subscriptionFormActionsV2.CONSUMPTION_MODULE_CALCULATE_PRICE_V2, calculateOfferPrice)
  yield takeLatest(subscriptionFormActionsV2.METER_MODULE_CHECK_DUPLICATED_PDL_V2, checkDuplicatedPdlMeter)
  yield takeLatest(subscriptionFormActionsV2.METER_MODULE_VALIDATE_PDL_METER_SYNTAX_V2, validatePdlMeterSyntax)
  yield takeLatest(subscriptionFormActionsV2.METER_MODULE_REQUEST_PDL_DATA_V2, requestPdlMeterData)
  yield takeLatest(subscriptionFormActionsV2.PDL_SEARCH_V2, searchPdl)
  yield takeLatest(subscriptionFormActionsV2.METER_MODULE_CHECK_DUPLICATED_PCE_V2, checkDuplicatedPceMeter)
  yield takeLatest(subscriptionFormActionsV2.METER_MODULE_VALIDATE_PCE_METER_SYNTAX_V2, validatePceMeterSyntax)
  yield takeLatest(subscriptionFormActionsV2.METER_MODULE_REQUEST_PCE_DATA_V2, requestPceMeterData)
  yield takeLatest(subscriptionFormActionsV2.PCE_SEARCH_V2, searchPce)
  yield takeLatest(subscriptionFormActionsV2.SAVE_ELECTRICITY_METER_V2, saveElectricityMeter)
  yield takeLatest(subscriptionFormActionsV2.SAVE_GAS_METER_V2, saveGasMeter)
  yield takeLatest(subscriptionFormActionsV2.CONTRACT_SAVE, saveContract)
  yield takeLatest(subscriptionFormActionsV2.CONTRACT_SAVE_FEEDBACK, saveContractFeedback)
  yield takeLatest(subscriptionFormActionsV2.RESEND_PROVIDER_EMAIL, resendProviderEmail)
  yield takeLatest(subscriptionFormActionsV2.LOAD_ADDITIONAL_SALES_CONFIG, loadAdditionalSaleConfig)
  yield takeLatest(subscriptionFormActionsV2.LOAD_EXISTING_ADDITIONAL_SALES, loadExistingAdditionalSales)
  yield takeLatest(subscriptionFormActionsV2.COMMUNICATION_BOARD_MODULE_LOAD_DATA, loadCommunicationBoardData)
  yield takeLatest(subscriptionFormActionsV2.BILLING_IBAN_VALIDATION, validateIban)
  yield takeLatest(subscriptionFormActionsV2.GENERATE_GARANKA_URL, generateGarankaUrl)
  yield takeLatest(subscriptionFormActionsV2.NEAT_RESEND_EMAIL_URL, neatResendEmail)
  yield takeLatest(subscriptionFormActionsV2.VOLTALIS_APPOINTMENT_URL, selectVoltalisAppointment)
  yield takeLatest(subscriptionFormActionsV2.VOLTALIS_STATUS_URL, getVoltalisStatus)
  yield takeLatest(subscriptionFormActionsV2.VOLTALIS_CUSTOMER_CALL_URL, voltalisCustomerCall)
  yield takeLatest(subscriptionFormActionsV2.AXA_SEND_MAIL, sendAxaMail)
  yield takeLatest(subscriptionFormActionsV2.CREATE_SCHEDULE_CALLBACK, createScheduleCallback)
  yield takeLatest(subscriptionFormActionsV2.LIST_SCHEDULE_CALLBACK, loadScheduledCallbacks)
  yield takeLatest(subscriptionFormActionsV2.CREATE_ADDITIONAL_SALE, createAdditionalSale)
  yield takeLatest(subscriptionFormActionsV2.RETRY_ADDITIONAL_SALE, retryAdditionalSale)
  yield takeLatest(
    subscriptionFormActionsV2.V2_ADDITIONAL_SALES_SEND_VALIDATION_CODE,
    sendAdditionalSalesCodeValidation,
  )
  yield takeLatest(subscriptionFormActionsV2.V2_ADDITIONAL_SALES_OPEN_SIGN_LINK, openPandaDocSignLink)
  yield takeLatest(subscriptionFormActionsV2.PROTECTED_SEND_SMS, protectedSendSms)
  yield takeLatest(subscriptionFormActionsV2.PROTECTED_SEND_NEW_OTP, protectedSendNewOtp)
  yield takeLatest(subscriptionFormActionsV2.CREATE_CLUB_SELECTRA, createClubSelectra)
  yield takeLatest(subscriptionFormActionsV2.BILLING_MODULE_FETCH_PROMO_CODE_V2, fetchPromoCode)
  yield takeLatest(subscriptionFormActionsV2.EXPORT_LOGS_V2, fetchExportLogs)
  yield takeLatest(subscriptionFormActionsV2.HISTORIC_LOGS_V2, fetchHistoricLogs)
  yield takeLatest(subscriptionFormActionsV2.LOAD_USERS_V2, fetchUsersList)
  yield takeLatest(subscriptionFormActionsV2.PROCESS_CHANGE_USER_V2, processChangeUser)
  yield takeLatest(subscriptionFormActionsV2.RETRACT_CONTRACT_V2, retractContract)
  yield takeLatest(subscriptionFormActionsV2.ADD_COMMENT_TO_CONTACT_V2, addCommentToContact)
  yield takeLatest(subscriptionFormActionsV2.CREDIT_CHECK, creditCheck)
  yield takeLatest(
    subscriptionFormActionsV2.OFFER_MODULE_VALIDATION_CONTRACT_NOT_DUPLICATED,
    validateContractIsNotDuplicated,
  )
  yield takeLatest(subscriptionFormActionsV2.LOAD_ENERGY_SUPPLIERS_V2, loadEnergySuppliers)
  yield takeLatest(subscriptionFormActionsV2.PROPANE_LOAD_QUOTE_REASONS_V2, loadPropaneQuoteReasons)
  yield takeLatest(subscriptionFormActionsV2.PROPANE_LOAD_VISIBILITY_V2, loadPropaneVisibility)
}
